import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  text: {
    marginLeft: '10%',
    marginRight: '10%',
    marginTop: '5vh',
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  header: {
    marginTop: theme.spacing(4),
  },
  subtitle: {
    fontSize: 21,
    fontWeight: 400,
  },
  question: {
    alignItems: 'center',
    display: 'flex',
    margin: theme.spacing(1),
    justifyContent: 'space-between',
  },
  radio: {
    marginLeft: theme.spacing(2),
  },
  importantText: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  }
}));
